<template>
  <FriedDropdown :main-axis-offset="8" :cross-axis-offset="0" :placement="Placement.BottomEnd">
    <template #trigger>
      <FriedIconButton
        :class="[{ 'post-menu-button-only-media': onlyMedia }]"
        data-external="post-menu-button"
      >
        <FriedIcon icon="ellipsis" />
      </FriedIconButton>
    </template>
    <template #content>
      <FriedDropdownItem
        v-for="option in options()"
        :key="option.callback"
        :class="option.class"
        :data-external="`post-options-menu-item-${option.callback}`"
        @click="$emit('select', option.callback)"
      >
        <template #leftIcon>
          <FriedIcon v-if="option.icon" :icon="option.icon" />
        </template>
        <FriedParagraph>{{ option.title }}</FriedParagraph>
      </FriedDropdownItem>
    </template>
  </FriedDropdown>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import { Placement } from '@getaccept/fried-tofu';
import type { Post } from '../../types';
import PostHelper from '../helpers/post.helper';

export default defineComponent({
  props: {
    post: {
      type: Object as PropType<Post>,
      required: true,
    },
    onlyMedia: {
      type: Boolean,
    },
  },
  emits: ['select'],
  setup() {
    return {
      options: PostHelper.getMenuOptions,
      Placement,
    };
  },
});
</script>
<style lang="scss" scoped>
.post-menu-button-only-media {
  .svg-icon {
    color: var(--white);
  }

  &:hover {
    .svg-icon {
      color: var(--base-blue);
    }
  }
}

.delete-option {
  &.dropdown-item-container {
    .button-icon {
      .svg-icon {
        color: var(--red-42);
      }
    }

    .dropdown-item-content {
      .paragraph {
        color: var(--red-42);
      }
    }
  }
}
</style>
